<template>
    <AuthLayout :title="$t('auth.login.title')" :description="$t('auth.login.description')">
        <form @submit.prevent="submitLogin">
            <InputComponent
                v-model="loginForm.email"
                placeholder="Email"
                type="email"
                :required="true"
                :errors="loginForm.errors.email"
            />
            <InputComponent
                v-model="loginForm.password"
                :placeholder="$t('auth.login.passwordPlaceholder')"
                type="password"
                :required="true"
                :errors="loginForm.errors.password"
            />
            <button class="submit-btn primary-btn" type="submit" :disabled="loginForm.processing">
                {{ $t('auth.login.submit') }}
            </button>
        </form>
    </AuthLayout>
</template>

<script>
import InputComponent from '@/components/form/InputComponent.vue'
import AuthLayout from '@/layouts/AuthLayout.vue'
import { useForm } from '@inertiajs/vue3'
import { useTransactionsStore } from '@/stores/transactionsStore.js'

export default {
    name: 'LoginPage',
    components: { AuthLayout, InputComponent },
    setup() {
        const transactionsStore = useTransactionsStore()

        return {
            transactionsStore
        }
    },
    data() {
        return {
            loginForm: useForm({
                email: null,
                password: null
            })
        }
    },
    mounted() {
        this.transactionsStore.$reset()
    },
    methods: {
        submitLogin() {
            this.loginForm.post(route('auth.login'), {
                preserveScroll: true,
                onSuccess: () => {
                    this.loginForm.reset()
                }
            })
        }
    }
}
</script>

<style lang="scss"></style>
